exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".schoolOrgUsageData table{font-size:.8em;margin-top:2rem}.schoolOrgUsageData tr{border-top:1px solid #ddd}.schoolOrgUsageData td,.schoolOrgUsageData th{padding:1rem;vertical-align:top;width:7%}.schoolOrgUsageData td:first-child,.schoolOrgUsageData th:first-child{width:16%}.schoolOrgUsageData th{font-size:.8em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/appdev/wizards/school_org_usage_data.scss
// module id = 831
// module chunks = 0